/* global jQuery COMPONENTS */

COMPONENTS.ComponentFeesTooltip = (function ($) {
  function ComponentFeesTooltip () {
    this.$toolTipToggles = $('[data-ecs-component-control="fees-tooltip"]')
    this.$toolTip = $('[data-ecs-component-element="fees-tooltip"]')
  }

  ComponentFeesTooltip.prototype.init = function () {
    const component = this

    component.$toolTipToggles.click(function () {
      $(component.$toolTip).toggleClass('ecs_active')
    })

    $(document).click(function (event) {
      const $target = $(event.target)
      if ($target.attr('data-ecs-component-control') !== 'fees-tooltip' && $target.attr('data-ecs-component-element') !== 'fees-tooltip') {
        $(component.$toolTip).removeClass('ecs_active')
      }
    })
  }

  return ComponentFeesTooltip
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentFeesTooltip = new COMPONENTS.ComponentFeesTooltip()
  COMPONENTS.componentFeesTooltip.init()
})
